<script lang="ts">
    import Search from '../../shared_components/Search.svelte';
    import Cart from '../../shared_components/Cart.svelte';
    import lang from '../../lang/language';
    import LanguageSelector from '../../shared_components/LanguageSelector.svelte';
    import WishlistInner from '../../shared_components/wishlist/WishlistInner.svelte';
    import ServicesAndMap from './ServicesAndMap.svelte';
    import StickyWishlist from '../../shared_components/wishlist/StickyWishlist.svelte';
    import Divider from '../../shared_components/Divider.svelte';
</script>

<div class="c-keyvisual">
    <div class="c-pageTitle">
        <h1><span class="c-pageTitle__subText" />{lang.search_title}</h1>
    </div>
    <div class="c-keyvisual__image">
        <figure>
            <img
                src="https://sangyosupport-shimada.com//pickup/images/kv_img.png"
                alt=""
            />
        </figure>
    </div>

    <div class="l-breadcrumb">
        <ul
            class="l-breadcrumb__list"
            itemscope="itemscope"
            itemtype="https://schema.org/BreadcrumbList"
        >
            <li
                itemprop="itemListElement"
                itemscope="itemscope"
                itemtype="https://schema.org/ListItem"
            >
                <a href="https://sangyosupport-shimada.com/" itemprop="item"
                    ><span itemprop="name">HOME</span></a
                >
                <meta itemprop="position" content="1" />
            </li>

            <li
                itemprop="itemListElement"
                itemscope="itemscope"
                itemtype="https://schema.org/ListItem"
            >
                <span itemprop="name" aria-current="location">{lang.list}</span>
                <meta itemprop="position" content="2" />
            </li>
        </ul>
        <!-- /l-breadcrumb -->
    </div>

    <!-- /c-keyvisual -->
</div>
<div class="box">
    <Cart />
    <div class="breadcrumb">
        <div />
        <div>
            <LanguageSelector />
        </div>
    </div>

    <ServicesAndMap slot="col-1" />
</div>

<style>
    .display-type > div {
        padding: 10px 20px;
        border: 0px;
        color: #113817;
        font-size: 1.1rem;
        transform: translateY(1px);
    }

    .display-type > div.active {
        background-color: #113817;
        color: #ffffff;
        border: 2px solid #113817;
        border-bottom: 0px;
    }
</style>
